import { createRouter, createWebHistory } from 'vue-router'
import authorization from '@/modules/users/authorization'
import Login from '@/pages/Authentication/Login'
import CreatePlace from '@/pages/Places/CreatePlace'
import PlacesList from '@/pages/Places/PlacesList'
import Index from '@/pages/Panel/Index'
import ImportXlsxPlaces from '@/pages/Tasks/ImportXlsxPlaces'
import TasksList from '@/pages/Tasks/TasksList'
import StorehouseListing from '@/pages/Storehouse/StorehouseListing'
import DriverListing from '@/pages/Drivers/DriverListing'
import CsvParser from '@/pages/Csv/CsvParser'
import CreateUser from '@/pages/User/CreateUser'
import UserList from '@/pages/User/UserList'
import Report from '@/pages/Report'
import EditPlace from '@/pages/Places/EditPlace'
import Unauthorized from '@/pages/Unauthorized'
import VehicleEditor from '@/pages/Storehouse/VehicleEditor'
import CreateTrailer from '@/pages/Trailers/CreateTrailer'
import CreateVehicle from '@/pages/Vehicles/CreateVehicle'
import EditTrailer from '@/pages/Trailers/EditTrailer'
import EditDriver from '@/pages/Drivers/EditDriver'
import NewParking from '@/pages/Parking/NewParking'
import EditParking from '@/pages/Parking/EditParking'
import ParkingList from '@/pages/Parking/ParkingList'
import ParkingShow from '@/pages/Parking/ParkingShow'
import MailingList from '@/pages/mailing/MailingListing'
import MailingAdd from '@/pages/mailing/MailingAdd'
import DriverAdd from '@/pages/Drivers/DriverAdd'
import DriverUnasignedListing from '@/pages/Drivers/DriverUnasignedListing'
import EditUser from '@/pages/User/EditUser.vue'
import Step1 from '@/pages/Tasks/createTask/Step1.vue'
import Step2 from '@/pages/Tasks/createTask/Step2.vue'
import ExportMonth from '@/pages/Tasks/ExportMonth.vue'
import VehiclesFilter from '@/pages/Vehicles/VehiclesFilter.vue'
import TrailersByParkings from '@/pages/Storehouse/TrailersByParkings.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Index,
    meta: {
      permissions: []
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      permissions: []
    }
  },
  {
    path: '/brak-uprawnien',
    name: 'Unauthorized',
    component: Unauthorized,
    meta: {
      permissions: []
    }
  },
  {
    path: '/zlecenia/:vrid?/:date?',
    name: 'TaskPanel',
    component: TasksList,
    meta: {
      permissions: []
    }
  },
  {
    path: '/zlecenia/dodaj',
    name: 'Step1',
    component: Step1,
    meta: {
      permissions: ['canCreateTasks']
    }
  },
  {
    path: '/zlecenia/dodaj/2',
    name: 'Step2',
    component: Step2,
    meta: {
      permissions: ['canCreateTasks']
    }
  },
  {
    path: '/miejsca',
    name: 'PlacesList',
    component: PlacesList,
    meta: {
      permissions: []
    }
  },
  {
    path: '/miejsca/dodaj/:acronym?',
    name: 'CreatePlace',
    component: CreatePlace,
    meta: {
      permissions: ['canEditMapPoints']
    }
  },
  {
    path: '/miejsca/edytuj/:id',
    name: 'EditPlace',
    component: EditPlace,
    meta: {
      permissions: ['canEditMapPoints']
    }
  },
  {
    path: '/magazyn',
    name: 'StoreHouseListing',
    component: StorehouseListing,
    meta: {
      permissions: []
    }
  },
  {
    path: '/magazyn/edycja-pojazdu/:id',
    name: 'VehicleEdit',
    component: VehicleEditor,
    meta: {
      permissions: ['canEditVehicles']
    }
  },
  {
    path: '/ciagniki/dodaj',
    name: 'CreateVehicle',
    component: CreateVehicle,
    meta: {
      permissions: ['canCreateVehicles']
    }
  },
  {
    path: '/naczepy/dodaj',
    name: 'CreateTrailer',
    component: CreateTrailer,
    meta: {
      permissions: ['canCreateVehicles']
    }
  },
  {
    path: '/edycja-naczepy/:id',
    name: 'EditTrailer',
    component: EditTrailer,
    meta: {
      permissions: ['canEditVehicles']
    }
  },
  {
    path: '/kierowcy',
    name: 'DriversListing',
    component: DriverListing,
    meta: {
      permissions: []
    }
  },
  {
    path: '/csv',
    name: 'Csv',
    component: ImportXlsxPlaces,
    meta: {
      permissions: ['canEditMapPoints']
    }
  },
  {
    path: '/csv-tasks',
    name: 'CsvTasks',
    component: CsvParser,
    meta: {
      permissions: []
    }
  },
  {
    path: '/user',
    name: 'UserList',
    component: UserList,
    meta: {
      permissions: []
    }
  },
  {
    path: '/user/create',
    name: 'CreateUser',
    component: CreateUser,
    meta: {
      permissions: ['canAddUsers']
    }
  },
  {
    path: '/uzytkownik/:id/edycja',
    name: 'EditUser',
    component: EditUser,
    meta: {
      permissions: []
    }
  },
  {
    path: '/report',
    name: 'Report',
    component: Report,
    meta: {
      permissions: []
    }
  },
  {
    path: '/Driver/:id',
    name: 'EditDriver',
    component: EditDriver,
    meta: {
      permissions: ['canEditDrivers']
    }
  },
  {
    path: '/Parking/nowy',
    name: 'CreateParking',
    component: NewParking,
    meta: {
      permissions: []
    }
  },
  {
    path: '/Parking/edycja/:id',
    name: 'EditParking',
    component: EditParking,
    meta: {
      permissions: []
    }
  },
  {
    path: '/Parking/lista',
    name: 'ParkingList',
    component: ParkingList,
    meta: {
      permissions: []
    }
  },
  {
    path: '/Parking/:id',
    name: 'ParkingShow',
    component: ParkingShow,
    meta: {
      permissions: []
    }
  },
  {
    path: '/parking/naczepy',
    name: 'TrailersByParkings',
    component: TrailersByParkings,
    meta: {
      permissions: []
    }
  },
  {
    path: '/mailing',
    name: 'MailingList',
    component: MailingList,
    meta: {
      permissions: []
    }
  },
  {
    path: '/mailing/dodaj',
    name: 'MailingAdd',
    component: MailingAdd,
    meta: {
      permissions: []
    }
  },
  {
    path: '/kierowcy/dodaj',
    name: 'DriverAdd',
    component: DriverAdd,
    meta: {
      permissions: ['canCreateDrivers']
    }
  },
  {
    path: '/Kierowcy/poczekalnia',
    name: 'DriverUnasignedListing',
    component: DriverUnasignedListing,
    meta: {
      permissions: []
    }
  },
  {
    path: '/zlecenia/eksport',
    name: 'EksportMonth',
    component: ExportMonth,
    meta: {
      permissions: []
    }
  },
  {
    path: '/vehicles-filter',
    name: 'VehiclesFilter',
    component: VehiclesFilter,
    meta: {
      permissions: []
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('accessToken') !== null
  if (to.name === 'Login' && isAuthenticated) {
    next({ name: 'Index' })
  }
  if (to.name !== 'Login' && !isAuthenticated) {
    next({ name: 'Login' })
  } else {
    authorization(to.meta.permissions)
    next()
  }
})

export default router
